export const ALINE_DOCUMENT_ID_DOCX_PROPERTY = 'alineDocumentId';
